import React, { Component } from 'react'
import NumberFormat from 'react-number-format'

// Components
import GeneralLoader from '../../../GeneralLoader'
import ErrorWrap from '../../../utils/error-success/ErrorWrap'

// CKeditor
import CKEditor from 'react-ckeditor-component'
import { editorReady } from '../../../../utils/editor'
import CKEditorInput from '../../../../utils/forms/CKEditorInput'

// CSS
import '../../../../css/forms/flex-experience-field.css'

class BioExperienceFieldset extends Component {
	constructor(props) {
		super(props)
		this.CKEditorInput = new CKEditorInput()

		this.dataProps = ['sectors', 'dietary_allergies', 'bio', 'experience', 'comments']
		this.miscProps = ['errors', 'sectorsError', 'sectorsLoading', 'sectors']
	}

	shouldComponentUpdate(nextProps) {
		// If the parent component is processing, we should re-render to show disabled states, etc
		if (this.props.inProcess !== nextProps.inProcess) {
			this.CKEditorInput.setCKReadonly(nextProps.inProcess)
			return true
		}

		// Check local props to see if any have changed
		const dataPropResults = this.dataProps.some(prop => {
			return this.props.data[prop] !== nextProps.data[prop]
		})
		const miscPropResults = this.miscProps.some(prop => {
			return this.props[prop] !== nextProps[prop]
		})

		// If any local props changed, we will rerender
		return dataPropResults || miscPropResults
	}

	render() {
		const { data, errors, sectorsLoading, sectorsError, sectors, inProcess } = this.props

		return (
			<div className='fieldset'>
				<div className='title-label'>Bio, Experience, Training</div>

				<div className='fieldset-indent'>
					<div className='floated-field-container'>
						{sectorsError ? (
							<ErrorWrap>{sectorsError}</ErrorWrap>
						) : sectorsLoading ? (
							<GeneralLoader />
						) : (
							<div className='form-field pb1'>
								<label>Work / Volunteer Experience:</label>

								{!!errors.sectors && <ErrorWrap animate={1}>{errors.sectors}</ErrorWrap>}

								{!sectors.length ? (
									<ErrorWrap>There are no experience options available at the moment.</ErrorWrap>
								) : (
									<React.Fragment>
										{Object.keys(sectors).map(key => {
											const { id } = sectors[key]

											// See if this sector is checked off
											const selectedObject = data.sectors.find(sector => {
												return sector.id === id
											})

											return (
												<div key={key} className='form-field flex-experience-field'>
													<div
														className={`custom-label checkbox-label${
															inProcess ? ' disabled-label' : ''
														}`}
													>
														<input
															type='checkbox'
															id={`experience_${key}`}
															value={id}
															checked={!!selectedObject}
															disabled={inProcess}
															onChange={e => this.props.handleCheckboxClickSector(e, 'sectors')}
														/>
														<label htmlFor={`experience_${key}`}>{sectors[key].title}</label>
													</div>
													<div className='years-wrap'>
														<NumberFormat
															placeholder='0'
															decimalScale={0}
															allowNegative={false}
															value={!!selectedObject ? selectedObject.years : null}
															type='text'
															onKeyPress={e => this.props.handleKeyPress(e)}
															onChange={e => this.props.handleInputChangeSector(e, id)}
															disabled={!selectedObject || inProcess}
														/>
														<label>Years</label>
													</div>
												</div>
											)
										})}
									</React.Fragment>
								)}
							</div>
						)}
					</div>

					<div className='form-field'>
						<label>Dietary Restrictions / Allergies:</label>

						{!!errors.dietary_allergies && (
							<ErrorWrap animate={1}>{errors.dietary_allergies}</ErrorWrap>
						)}
						<input
							type='text'
							id='dietary_allergies'
							value={data.dietary_allergies}
							maxLength='255'
							disabled={inProcess}
							onKeyPress={e => this.props.handleKeyPress(e)}
							onChange={e => this.props.handleInputChange(e)}
						/>
					</div>

					<div className='form-field'>
						<label>Accessibility Requirements:</label>

						{!!errors.bio && <ErrorWrap animate={1}>{errors.accessibility_requirements}</ErrorWrap>}
						{console.log(data.accessibility_requirements)}
						<CKEditor
							scriptUrl='/ckeditor/ckeditor.js'
							content={data.accessibility_requirements}
							config={{
								toolbar: 'BasicWithTools',
								filebrowserBrowseUrl: '/file-browser',
								uploadUrl: process.env.REACT_APP_API_URL + `files`,
							}}
							events={{
								instanceReady: editorReady.bind(this),
								change: this.props.editorChange.bind(this, 'accessibility_requirements'),
							}}
							ref={instance => {
								this.CKEditorInput.addEditor('accessibility_requirements', instance)
							}}
						/>
					</div>

					<div className='form-field'>
						<label>Bio:</label>

						{!!errors.bio && <ErrorWrap animate={1}>{errors.bio}</ErrorWrap>}
						{console.log(data.bio)}
						<CKEditor
							scriptUrl='/ckeditor/ckeditor.js'
							content={data.bio}
							config={{
								toolbar: 'BasicWithTools',
								filebrowserBrowseUrl: '/file-browser',
								uploadUrl: process.env.REACT_APP_API_URL + `files`,
							}}
							events={{
								instanceReady: editorReady.bind(this),
								change: this.props.editorChange.bind(this, 'bio'),
							}}
							ref={instance => {
								this.CKEditorInput.addEditor('bio', instance)
							}}
						/>
					</div>

					<div className='form-field'>
						<label>Other Relevant Experience, Training or Certs.:</label>

						{!!errors.experience && <ErrorWrap animate={1}>{errors.experience}</ErrorWrap>}
						<CKEditor
							scriptUrl='/ckeditor/ckeditor.js'
							content={data.experience}
							config={{
								toolbar: 'BasicWithTools',
								filebrowserBrowseUrl: '/file-browser',
								uploadUrl: process.env.REACT_APP_API_URL + `files`,
							}}
							events={{
								instanceReady: editorReady.bind(this),
								change: this.props.editorChange.bind(this, 'experience'),
							}}
							ref={instance => {
								this.CKEditorInput.addEditor('experience', instance)
							}}
						/>
					</div>

					<div className='form-field'>
						<label>Reviewer Comments:</label>

						{!!errors.comments && <ErrorWrap animate={1}>{errors.comments}</ErrorWrap>}
						<CKEditor
							scriptUrl='/ckeditor/ckeditor.js'
							content={data.comments}
							config={{
								toolbar: 'BasicWithTools',
								filebrowserBrowseUrl: '/file-browser',
								uploadUrl: process.env.REACT_APP_API_URL + `files`,
							}}
							events={{
								instanceReady: editorReady.bind(this),
								change: this.props.editorChange.bind(this, 'comments'),
							}}
							ref={instance => {
								this.CKEditorInput.addEditor('comments', instance)
							}}
						/>
					</div>
				</div>
			</div>
		)
	}
}

export default BioExperienceFieldset



// WEBPACK FOOTER //
// ./src/components/admin/reviewers/form-components/BioExperienceFieldset.js